import React from 'react';
import { WelcomeMessageWrapper, FooterWrapper, StyledButton } from './WelcomeMessage.styles';

export function WelcomeMessage({setSignUpState}) {
  return (
    <WelcomeMessageWrapper>
      <h3>Welcome back!</h3>
      <p>Login to your account to stay connected with us and access all the great features DoveMed has to offer.</p>
      <FooterWrapper>
        <p>Dont have an account yet?</p>
        <StyledButton onClick={() => setSignUpState(true)}>Signup</StyledButton>
      </FooterWrapper>
    </WelcomeMessageWrapper>
  )
}
